<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">结算规则</div>
      <div>
        <blue-title class="style">结算规则</blue-title>
        <div>
          <div class="info">
            <span class="marRight">结算规则信息</span
            ><span class="ruleInfo"
              ><span>{{settlementRulesData.settlementId}}</span
              ><span>------</span></span
            >
          </div>
          <div class="info"><span class="marRight">特殊资质</span><span>{{settlementRulesData.qualifications}}</span></div>
        </div>
      </div>
      <div class="info" style="height: 70px">
        <span class="marRight"></span
        ><span
          ><el-image
            :src="settlementRulesData.qualificationsCopy"
            alt=""
            style="width: 58px; height: 58px"
          ></el-image
        ></span>
      </div>
      <!-- <div class="info"><span class="marRight">优惠费率活动</span><span>慈善公益活动</span></div> -->
      <!-- <div class="info"><span class="marRight">优惠费率活动值</span><span>0.22%</span></div> -->

      <!-- <div class="info" style="height: 70px">
        <span class="marRight">优惠费率活动补充材料</span
        ><span
          ><el-image
            src="http://tupian201805.oss-cn-beijing.aliyuncs.com/2022/1/10/1644484450446_58155aa381764d188fbd8580c4bcc199.jpeg"
            alt=""
            style="width: 58px; height: 58px"
          ></el-image
        ></span>
      </div> -->
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="next">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { draftEcho } from '../../../../api/module/merchants';

export default {
  components: {},
  props: {},
  data() {
    return {
      settlementRulesData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    next() {
      const { uuid } = this;
      this.$router.push({
        path: '/merchants/bankDetails',
        query: {
          uuid,
        },
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.settlementRulesData = result.settlementRulesVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 9px 0 20px 0;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    width: 90px;
    margin-right: 38px;
  }
  .ruleInfo {
    display: flex;
    justify-content: space-between;
  }
  .btn {
    margin-top: 50px;
  }
}
</style>
